import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecommendationDetails } from "../../../RecommendationDetailsProvider";
import { HeaderRow } from "./HeaderRow";
import { InfoRow } from "./InfoRow";
import { useGetProductInfo } from "./useGetProductInfo";

export const ProductInfoSection = () => {
  const { names } = useRecommendationDetails();
  const { t } = useTranslation();

  const rows = useGetProductInfo();

  return (
    <Box>
      <Typography variant="subtitle2" mb={10}>
        {t("recommender.compareView.productInfo.title")}
      </Typography>
      <Grid2 container>
        <HeaderRow
          investmentName={names.investment}
          recommendationName={names.recommendation}
        />
      </Grid2>
      {rows.map((row, index) => (
        <InfoRow
          key={`${row.label}-${index}`}
          label={row.label}
          value1={row.value1}
          value2={row.value2}
          withTopBorder
        />
      ))}
    </Box>
  );
};
